import { createFileRoute } from '@tanstack/react-router'
import { Footer } from '@/components/footer'
import { CtaBand } from '@/components/landing/cta-band'
import { FeaturesGrid } from '@/components/landing/features-grid'
import { Hero } from '@/components/landing/hero'
import { PricingPreview } from '@/components/landing/pricing-preview'
import { NavBar } from '@/components/nav-bar'

export const Route = createFileRoute('/')({
  component: LandingPage,
})

function LandingPage() {
  return (
    <>
      <NavBar />
      <main className="flex min-h-screen flex-col">
        <Hero />
        <FeaturesGrid />
        <PricingPreview />
        <CtaBand />
      </main>
      <Footer />
    </>
  )
}
